import { SET_BRAND_SOURCE_TYPE } from 'actions';

export function setBrandSourceType(sourceType: string) {
  return { sourceType, type: SET_BRAND_SOURCE_TYPE };
}
